import axios from "axios";
import { push } from "react-router-redux";
import { createFlash, createError } from "./flasher";
import { advanceSchedulingApi } from "./auth";

const baseAPI = process.env.REACT_APP_BASE_API;

export const fetchOrders = (params = "", accessToken) => {
  return (dispatch) => {
    dispatch({
      type: "FETCH_ORDERS_PENDING",
    });
    return axios({
      method: "get",
      headers: { Authorization: `Bearer ${accessToken}` },
      url: `${baseAPI}/orders${params}`,
    })
      .then((x) => {
        dispatch({
          type: "FETCH_ORDERS_FULFILLED",
          payload: {
            data: x.data,
            pagination: {
              currentPage: x.headers["x-pagination-current-page"],
              pageCount: x.headers["x-pagination-page-count"],
              perPage: x.headers["x-pagination-per-page"],
              totalCount: x.headers["x-pagination-total-count"],
            },
          },
        });
      })
      .catch((e) => {
        console.error(e);
        // dispatch(createError(e.response.data))
        dispatch({
          type: "FETCH_ORDERS_REJECTED",
          payload: e,
        });
      });
  };
};

export const fetchOrder = (id, accessToken) => {
  return (dispatch) => {
    dispatch({
      type: "FETCH_ORDER_PENDING",
    });
    return axios({
      method: "get",
      headers: { Authorization: `Bearer ${accessToken}` },
      url: `${baseAPI}/orders/${id}?expand=questionnaire,questionnaire_item,schedules`,
    })
      .then((x) => {
        dispatch({
          type: "FETCH_ORDER_FULFILLED",
          payload: x.data,
        });
      })
      .catch((e) => {
        console.error(e);
        // dispatch(createError(e.response.data))
        dispatch({
          type: "FETCH_ORDER_REJECTED",
          payload: e,
        });
      });
  };
};

export const updateOrder = (data, accessToken, target) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_ORDER_PENDING",
    });

    return axios({
      data,
      method: "put",
      headers: { Authorization: `Bearer ${accessToken}` },
      url: `${baseAPI}/orders/${data.id}?expand=questionnaire,questionnaire_item,schedules`,
    })
      .then((x) => {
        if (
          data.id &&
          (data.status === "Prerequisite Not Complete" ||
            data.status === "Prerequisite Completed" ||
            data.status === "Prerequisite Submitted")
        ) {
          axios
            .put(`${advanceSchedulingApi}/orders/assign/${data.id}`)
            .then((res) => {
              console.log({ res });
            })
            .catch((err) => {
              // Advance-scheduling assignment is a background side-effect; its
              // failure (service unavailable / connection refused) must not
              // surface as an uncaught rejection or block the order update.
              console.error("advance-scheduling assign failed", err);
            });
        }
        dispatch({
          type: "UPDATE_ORDER_FULFILLED",
          payload: x.data,
        });
        dispatch(
          createFlash({
            id: Date.now(),
            type: "success",
            message: `Order with the id ${x.data.id} updated`,
          })
        );
        if (target) {
          dispatch(push(target));
        }
        // Resolve with the updated order so callers that need to know the
        // outcome (e.g. a confirmation modal kept open while the request runs)
        // can distinguish success from the swallowed failure below.
        return x.data;
      })
      .catch((e) => {
        console.error(e);
        dispatch(createError(e.message));
        dispatch({
          type: "UPDATE_ORDER_REJECTED",
          payload: e,
        });
        // Not re-thrown (existing callers have no .catch); surface as a value.
        return { error: e };
      });
  };
};

export const submitCompletenessCheck = (id, formData, accessToken) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_ORDER_PENDING",
    });

    return axios({
      data: formData,
      method: "post",
      headers: { Authorization: `Bearer ${accessToken}` },
      url: `${baseAPI}/orders/${id}/completeness-check?expand=questionnaire,questionnaire_item,schedules`,
    })
      .then((x) => {
        dispatch({
          type: "UPDATE_ORDER_FULFILLED",
          payload: x.data,
        });
        dispatch(
          createFlash({
            id: Date.now(),
            type: "success",
            message: `Order completeness check submitted`,
          })
        );
      })
      .catch((e) => {
        console.error(e);
        dispatch(createError(e.message));
        dispatch({
          type: "UPDATE_ORDER_REJECTED",
          payload: e,
        });
      });
  };
};

export const useDetailOrder = async ({ token, orderId }) => {
  try {
    const res = await axios.get(
      `${advanceSchedulingApi}/orders/${orderId}`,
      undefined,
      {
        headers: {
          Authorization: token ? `Bearer ${btoa(token)}` : undefined,
        },
      }
    );
    return res.data;
  } catch (error) {
    console.log("error =>", error);
  }
};

export const vetoApprove = (id, formData, accessToken) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_ORDER_PENDING",
    });

    return axios({
      data: formData,
      method: "post",
      headers: { Authorization: `Bearer ${accessToken}` },
      url: `${baseAPI}/orders/${id}/veto-approve`,
    })
      .then((x) => {
        dispatch({
          type: "UPDATE_ORDER_FULFILLED",
          payload: x.data,
        });
        dispatch(
          createFlash({
            id: Date.now(),
            type: "success",
            message: `Order veto approved`,
          })
        );
        dispatch(push(`/orders/${id}`));
      })
      .catch((e) => {
        console.error(e);
        dispatch(createError(e.message));
        dispatch({
          type: "UPDATE_ORDER_REJECTED",
          payload: e,
        });
      });
  };
};

export const vetoReject = (id, formData, accessToken) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_ORDER_PENDING",
    });

    return axios({
      data: formData,
      method: "post",
      headers: { Authorization: `Bearer ${accessToken}` },
      url: `${baseAPI}/orders/${id}/veto-reject`,
    })
      .then((x) => {
        dispatch({
          type: "UPDATE_ORDER_FULFILLED",
          payload: x.data,
        });
        dispatch(
          createFlash({
            id: Date.now(),
            type: "success",
            message: `Order veto rejected`,
          })
        );
        dispatch(push(`/orders/${id}`));
      })
      .catch((e) => {
        console.error(e);
        dispatch(createError(e.message));
        dispatch({
          type: "UPDATE_ORDER_REJECTED",
          payload: e,
        });
      });
  };
};

// Phase 2 — publish ONE Veto Review section (per veto person). Returns the
// response data so the caller can react to `data.finalized` (last section →
// order status auto-advanced). Does not navigate; the caller reloads the order.
export const vetoSection = (id, formData, accessToken) => {
  return (dispatch) => {
    dispatch({ type: "UPDATE_ORDER_PENDING" });

    return axios({
      data: formData,
      method: "post",
      headers: { Authorization: `Bearer ${accessToken}` },
      url: `${baseAPI}/orders/${id}/veto-section`,
    })
      .then((x) => {
        dispatch({ type: "UPDATE_ORDER_FULFILLED", payload: x.data });
        dispatch(
          createFlash({
            id: Date.now(),
            type: "success",
            message: (x.data && x.data.message) || "Veto section published",
          })
        );
        return x.data;
      })
      .catch((e) => {
        console.error(e);
        dispatch(
          createError(
            (e.response && e.response.data && e.response.data.message) ||
              e.message
          )
        );
        dispatch({ type: "UPDATE_ORDER_REJECTED", payload: e });
        throw e;
      });
  };
};
